import React, { useState } from "react";
import {
  Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
} from "reactstrap";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { IN_COSTA_RICA_STATUS, IN_MIAMI_STATUS, IN_TRANSIT_STATUS, MOVEMENT_STATUS } from "utils/Constants";
import { useNavigate } from "react-router-dom";
import DynamicForm from "components/DynamicForm";

const AdminPackagesTable = props => {
  const navigate = useNavigate();
  const { packagesList, packagesFilterType } = props
  const [typeAheadFilter, setTypeAheadFilter] = useState("");

  const rowActions = (box) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/edit/${box.id}`) }}>
            Editar Paquete
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/cost/${box.id}`) }}>
            Editar Costo de Paquete
          </DropdownItem>
          {box.cargoMovement && box.cargoMovement.id && (
            <DropdownItem onClick={(e) => { navigate(`/admin/cargo-movement/edit/${box.cargoMovement.id}`) }}>
              Editar Movimiento de Carga
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  const renderFilteredPackages = () => {
    const filteredStatusPackages = packagesList.filter(p => {
      switch (packagesFilterType) {
        case "preOrders":
          return !p.received;
        case "inMiami":
          return (!p.cargoMovement ||
            (p.cargoMovement && IN_MIAMI_STATUS.includes(p.cargoMovement.status))
          );
        case "inTransit":
          return (p.cargoMovement && IN_TRANSIT_STATUS.includes(p.cargoMovement.status))
        case "inCostaRica":
          return (p.cargoMovement && IN_COSTA_RICA_STATUS.includes(p.cargoMovement.status))
      }
    })

    const filteredPackages = doTypeAheadFilter(filteredStatusPackages);
    if (filteredPackages.length > 0) {
      return filteredPackages.map((p, i) => (
        <tr key={`package-i-${i}`}>
          <td>{p.secuencia}</td>
          <td>{p.warehouseNumber}</td>
          <td>{p.tracking_num}</td>
          <td>{p.client}</td>
          <td>{p.cargoMovement && MOVEMENT_STATUS[p.cargoMovement.status]}</td>
          <td className="d-flex">
            <Button className="ms-1" size="sm" color="primary" onClick={(e) => { navigate(`/admin/package/edit/${p.id}`) }}>
              Ver
            </Button>
            <div className="ms-1">
              {rowActions(p)}
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan={6}> No hay paquetes para el tipo de movimiento seleccionado</td>
        </tr>
      )
    }

  }

  const doTypeAheadFilter = (packages) => {
    if (typeAheadFilter) {
      const textFilter = typeAheadFilter.toLowerCase()
      return packages.filter(p => {
        return (p.client || "").toLowerCase().includes(textFilter) ||
          (p.tracking_num || "").toLowerCase().includes(textFilter) ||
          (p.warehouseNumber || "").toLowerCase().includes(textFilter) ||
          (p.secuencia || "").toLowerCase().includes(textFilter)
      });
    }
    return packages;

  }

  const typeAHeadSearch = (search) => {
    setTypeAheadFilter(search);
  }

  const getSearchForm = () => {
    return {
      sections: [{
        fields: [
          [
            {
              "type": "text",
              "name": "q",
              "label": "Buscar Paquete",
              "disabled": false,
              "sizing": {
                "sm": 6
              }
            },
          ]
        ]
      }]
    };

  }

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle tag="h5">
            Lista de Paquetes
          </CardTitle>
          <CardText>
            <DynamicForm
              id="search"
              formConfig={getSearchForm()}
              onInputChange={(fieldName, v) => typeAHeadSearch(v)}>
            </DynamicForm>
            <Table responsive>
              <thead>
                <tr>
                  <th># Paquete</th>
                  <th>Warehouse</th>
                  <th># Tracking</th>
                  <th>Client</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {renderFilteredPackages()}
              </tbody>
            </Table>
          </CardText>
        </CardBody>
      </Card >
    </>
  );
}

export default AdminPackagesTable;
